import { h, Component, Fragment, createRef } from 'preact';

export default class SelectorComponent extends Component {
    constructor() {
        super();
        this.state = {
            showFilter: false
        };

        this.closeOnDeselect = this.closeOnDeselect.bind(this);
        this.ref = createRef();
    }

    isSelected(option) {
        // console.log('%cTRACE: isSelected', 'color: green; font-weight: 900; background: white')
        return option.id === this.props.selected?.id;
    }

    toggleDropdown() {
        this.setState({ showFilter: !this.state.showFilter });
    }

    select(option) {
        // console.log('%cTRACE: select', 'color: green; font-weight: 900; background: white')
        this.props.onSelect(option);
        this.setState({showFilter: false});
    }

    componentDidUpdate() {
        // console.log('%cTRACE: componentDidUpdate', 'color: green; font-weight: 900; background: white')
        if (this.props.options.length === 1 && !this.props.selected) {
            this.props.onSelect(this.props.options[0]);
        }
    }

    closeOnDeselect(event) {
        // console.log('%cTRACE: closeOnDeselect', 'color: green; font-weight: 900; background: white')
        if (this.ref && !this.ref.current.contains(event.target) && this.state.showFilter) {
            this.setState({showFilter: false});
        }
    }

    componentDidMount() {
        // console.log('%cTRACE: componentDidMount', 'color: green; font-weight: 900; background: white')
        document.addEventListener("mousedown", this.closeOnDeselect);
    }

    componentWillUnmount() {
        // TODO find a better solution then this document event mount for closing div
        document.removeEventListener("mousedown", this.closeOnDeselect);
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <div class="filter selector" ref={self.ref}>
                    {/* Filter Button */}
                    <button class={`filter-toggle ${self.props.options?.length > 0 ? '' : 'disabled'}`} disabled={!self.props.options?.length} onclick={() => self.toggleDropdown()}>
                        {!self.props.selected ? self.props.message : self.props.selected.label}
                        <span class={`caret ${self.state.showFilter ? 'selected' : ''}`}></span>
                    </button>
                    {/* Filter Area */}
                    <ul class={`filter-menu ${self.state.showFilter ? 'show-filter' : 'hide-filter'}`}>
                        {
                            self.props.options?.map(option => {
                                return (
                                    <li key={option.id} class="list">
                                        <button class={`${self.isSelected(option) ? 'selected' : ''}`} data-ga={self.props.ga} onclick={() => self.select(option)}>{option.label}</button>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </Fragment>
        );
    }
}
